import classNames from 'clsx';
import React from 'react';
import type { RouteComponentProps } from 'react-router';

import CrmZone from '@swf/components/CrmZone/CrmZone';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import type { Variant } from '@swf/components/StarsModal/components/CloseButton';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import { CRMZone } from '@swf/core/enums';
import { Size } from '@swf/core/models/modal';
import type { CrmComponentType } from '@swf/generated/types/common/Crm';

import { TXTCLI_My_News } from './StarsCrm.messages.json';
import styles from './StarsCrm.scss';
import { zoneStyles } from './constants';

export interface LocationStateProps {
  className?: string;
  zoneId: string;
  componentType: CrmComponentType;
  icon?: Variant;
  scrolling?: string;
  size?: Size;
  headerVariant?: string;
}

type StarsCrmProps = RouteComponentProps<{ zoneID: string }, object, LocationStateProps>;

const getClassNames = (props: LocationStateProps) =>
  classNames(styles.modal, zoneStyles[props.zoneId], props.className);

class StarsCrm extends React.PureComponent<StarsCrmProps> {
  static contextType = ModalContext;

  constructor(props: StarsCrmProps, context: ModalContextValue) {
    super(props, context);
    context.setStyle({
      size: props.location.state.size || Size.MEDIUM,
      className: getClassNames(props.location.state)
    });
  }

  renderTitle = () => {
    const { zoneId }: LocationStateProps = this.props.location.state;
    switch (zoneId) {
      case CRMZone.MY_NEWS:
        return <Translation {...TXTCLI_My_News} />;
      default:
        return;
    }
  };

  render() {
    const { headerVariant, icon, componentType, scrolling } = this.props.location.state;
    const { zoneID } = this.props.match.params;
    const headerTitle = this.renderTitle();

    return (
      <>
        {headerTitle && (
          <Header
            className={classNames(styles.header, headerVariant && styles[headerVariant as string])}
          >
            {headerTitle}
          </Header>
        )}
        {zoneID !== CRMZone.STARS_REWARDS_OPT_IN && (
          <CloseButton
            variant={icon}
            className={headerTitle ? styles.withHeader : styles.withoutHeader}
          />
        )}
        <CrmZone
          zoneId={zoneID}
          componentType={componentType}
          scrolling={scrolling}
          dynamicHeight
        />
      </>
    );
  }
}

export default StarsCrm;
